import { ChangeDetectionStrategy, Component, Input, OnInit ,ViewChild,ElementRef} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IEncuestaResponse } from '../../models/encuesta.model';
import { TipoPreguntaEncuestaSatisfaccionEnum } from '../../enumeraciones/tipos-preguntas-encuesta-satisfaccion';
import { AuthService } from '../../services/auth.service';
import { EstablecimientoComercioService } from '../../../components/core/containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { ModalAjusteRntComponent } from 'src/app/components/core/layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';
import { ModalConfirmarRespuestaComponent } from '../modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from '../../models/confirmar-respuesta.model';

@Component({
  selector: 'app-modal-encuesta-satisfaccion',
  templateUrl: './modal-encuesta-satisfaccion.component.html',
  styleUrls: ['./modal-encuesta-satisfaccion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalEncuestaSatisfaccionComponent implements OnInit {

  
	@Input()
	encuestaModel: IEncuestaResponse;
  preguntaAbiertaModel: string=null;
  currentStep : number = 0;
  tipoPreguntaAbierta = TipoPreguntaEncuestaSatisfaccionEnum.Abierta;
  tipoPreguntaCheck = TipoPreguntaEncuestaSatisfaccionEnum.Checkbox;
  tipoPreguntaEmoji = TipoPreguntaEncuestaSatisfaccionEnum.Emoji;
  tipoPreguntaSeleccionMultiple = TipoPreguntaEncuestaSatisfaccionEnum.Seleccion_Multiple;


	constructor(public activeModal: NgbActiveModal,
              private AuthService: AuthService,
              private modalService: NgbModal,
              private EstablecimientoComercioService: EstablecimientoComercioService) {}

	ngOnInit() {
	}

	confirm(): void {
		this.submitAnswers(false);
    this.activeModal.close();
    
	}
  get isValidAnswers(): boolean {
    return this.encuestaModel.preguntas.every(i => i.valor != null);
  }

	dismiss(): void {
		this.activeModal.dismiss();
	}
  stepSwitch(type: string): void{
    switch(type){
      case '+':
        this.currentStep++;
        break;
      case '-':
        this.currentStep--;
          break;
    }

    this.modelToTextArea();
       
  }
  modelToTextArea(): void{ 
    this.preguntaAbiertaModel = null;  
    if(this.encuestaModel.preguntas[this.currentStep].tipo_Pregunta_Id === this.tipoPreguntaAbierta){      
      if(this.encuestaModel.preguntas[this.currentStep].valor != null){  
        this.preguntaAbiertaModel = this.encuestaModel.preguntas[this.currentStep].valor;
      }
    }
  }
  textAreaToModel(event){
    this.encuestaModel.preguntas[this.currentStep].valor= event;
    this.preguntaAbiertaModel=event;
  }
  submitAnswers(isAnticipada: boolean): void{
    let request =this.encuestaModel;
    //FILTER QUESTIONS IF HAS A VALID ANSWER
    request.preguntas = request.preguntas.filter(x=> x.valor != null);
    request.preguntas.forEach(p =>{
      if(Array.isArray(p.valor)){
        p.valor = p.valor.join(',');
      }
    })
    if( request.preguntas.length > 0){  
        this.AuthService
            .enviarEncuestaSatisfaccion(request)
            .subscribe(response =>{
              if(response.data == null){
                localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(false));
                if(!isAnticipada){
                  this.onModalAgradecimiento();
                }
              }
            });
    }
  }
  private onModalAgradecimiento(): void{
    this.EstablecimientoComercioService
      .getParametro({
        parametro_id:
          "INFO_FINALIZAR_ENCUESTA_SATISFACCION",
        agrupacion: "TEXTO",
        auxiliar: "1",
    })
    .subscribe(
      (resultado2) => {
        if (resultado2.result) {
          const modalAceptarRenovacion = this.modalService.open(
            ModalAjusteRntComponent,
            { centered: true, backdrop: "static", size: "md" }
          );
          modalAceptarRenovacion.componentInstance.mensaje =
            resultado2.data;
        }
      }
    );
  }
  onDismiss(): void{
    this.onModalCerrarAnticipadamente();
  }
  
  onModalCerrarAnticipadamente(): void {
		this.EstablecimientoComercioService
		  .getParametro({
            parametro_id: "ADVERTENCIA_CERRAR_ENCUESTA_SATISFACCION",
            agrupacion: "TEXTO",
            auxiliar: "1",
		    })
		  .subscribe((resultado) => {
        if (!resultado?.result) return;
        const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
        const confirmarRespuesta = {} as ConfirmarRespuestaModel;
        confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
        confirmarRespuesta.message = resultado.data;
        modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
        modalRef.closed.subscribe(() => {
          localStorage.setItem('tieneEncuestaPendiente',JSON.stringify(true));
          this.submitAnswers(true);
          this.modalService.dismissAll();
        });
		  });
	  }
}
